module.exports = __webpack_public_path__ + "media/img/banner/supervenue-514bfcba8e4d6265a4ae3b17d7fdab58.png";